Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var stackContext = require('@alfalab/stack-context');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var Stack = function (_a) {
    var children = _a.children, _b = _a.value, value = _b === void 0 ? stackContext.stackingOrder.DEFAULT : _b;
    var previousValue = React.useContext(stackContext.StackingContext);
    var currentValue = Math.max(value, previousValue);
    var nextValue = currentValue + 1;
    return (React__default.default.createElement(stackContext.StackingContext.Provider, { value: nextValue }, children(currentValue)));
};

exports.Stack = Stack;
